import AbstractRestClient from '../AbstractRestClient';

class ShippingRestClient extends AbstractRestClient {
  fetchStates(carrier, action) {
    return this.instance.get('/api/es_ar/shipping/states/list', {
      params: {
        carrier,
        action
      }
    });
  }

  fetchCarriers(region, postalCode) {
    return this.instance.get(`/api/es_ar/shipping/carriers/${region}/region`, {
      params: { postalCode }
    });
  }

  fetchStores(carrier, region) {
    return this.instance.get(
      `/api/es_ar/shipping/carriers/${carrier}/regions/${region}/stores`
    );
  }

  calculateShipping(postalCode, products, shippingAddress = '') {
    return this.instance.post('/api/es_ar/shipping/estimates', {
      postcode: postalCode,
      products,
      shippingAddress
    });
  }

  fetchPickupStores() {
    return this.instance.get('/api/es_ar/shipping/pickup');
  }

  fetchRegions(state, carrier, action) {
    return this.instance.get(`/api/es_ar/shipping/states/${state}/regions`, {
      params: {
        carrier,
        action
      }
    });
  }
}

export default new ShippingRestClient();
